import React, { useState } from "react";
import { Modal, Button, Row, Col, Divider, Input, Form, Card, Image } from "antd";
import { CloseCircleOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons";
import "./MaterialSummary.css";

export interface MaterialSummaryProps {
  showSummary: boolean;
  materialsList: any[];
  hideSummary: () => void;
  getBagInfo: (material: any) => any;
}

const MaterialSummary = (props: MaterialSummaryProps) => {
  const getMaterialsSummary = (materials: any[]) => {
    let materialsSummary: any[] = [];
    let metalIDs: string[] = [];
    let currMaterials = [...materials];
    currMaterials.forEach((material: any) => {
      if (metalIDs.includes(material.metalID)) {
        let currMaterial = materialsSummary.find(
          (materialSummary: any) => materialSummary.metalID === material.metalID
        );
        currMaterial.rawWeight = (Number(currMaterial.rawWeight) + Number(material.rawWeight)).toFixed(1);
        currMaterial.wasteWeight = (Number(currMaterial.wasteWeight) + Number(material.wasteWeight)).toFixed(1);
        currMaterial.netWeight = (Number(currMaterial.netWeight) + Number(material.netWeight)).toFixed(1);
        currMaterial.smallBag = Number(currMaterial.smallBag) + Number(material.smallBag);
        currMaterial.bigBag = Number(currMaterial.bigBag) + Number(material.bigBag);
        currMaterial.jumboBag = Number(currMaterial.jumboBag) + Number(material.jumboBag);
      } else {
        metalIDs.push(material.metalID);
        materialsSummary.push({ ...material });
      }
    });
    return materialsSummary;
  };

  return (
    <Modal
      title="Materials Summary"
      width={"70%"}
      open={props.showSummary}
      okButtonProps={{ style: { display: "none" } }}
      cancelText="Close Summary View"
      onCancel={props.hideSummary}
    >
      <Row>
        {getMaterialsSummary(props.materialsList).map((material: any, index: number) => {
          return (
            <Col span={6}>
              <Card className="summary-materials-card" bodyStyle={{ padding: 0 }}>
                <Row style={{ height: "150px" }}>
                  <Col span={24}>
                    <Row justify="start">
                      <h3>
                        <b>
                          {index + 1}. {material.displayName}
                        </b>
                      </h3>
                    </Row>
                    <Row>
                      <Col span={5}>
                        <h3>Raw:</h3>
                      </Col>
                      <Col span={6}>
                        <Row justify="end">
                          <h3>{Number(material.rawWeight).toFixed(1)}</h3>
                        </Row>
                      </Col>
                      <Col span={3}>
                        <Row justify="end">
                          <h3>kg</h3>
                        </Row>
                      </Col>
                      <Col span={10}>
                        <Row justify="center">
                          <h3>{props.getBagInfo(material)}</h3>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={5}>
                        <h3>Waste:</h3>
                      </Col>
                      <Col span={6}>
                        <Row justify="end">
                          <h3>- {Number(material.wasteWeight).toFixed(1)}</h3>
                        </Row>
                      </Col>
                      <Col span={3}>
                        <Row justify="end">
                          <h3>kg</h3>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Divider style={{ margin: "5px 0", backgroundColor: "black" }} />
                    </Row>
                    <Row>
                      <Col span={5}>
                        <h3>
                          <b>Net:</b>
                        </h3>
                      </Col>
                      <Col span={6}>
                        <Row justify="end">
                          <h3>
                            <b>{Number(material.netWeight).toFixed(1)}</b>
                          </h3>
                        </Row>
                      </Col>
                      <Col span={3}>
                        <Row justify="end">
                          <h3>
                            <b>kg</b>
                          </h3>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          );
        })}
      </Row>
    </Modal>
  );
};

export default MaterialSummary;
